class RecentlyViewedProducts extends HTMLElement {
    constructor() {
        super();
        this.storageKey = 'shopify:rv-handles';
        this.maxStore = 20;
        this.maxDisplay = parseInt(this.dataset.maxProducts, 10) || 4;
        this.currentHandle = this.dataset.productHandle || null;
    }

    connectedCallback() {
        this.trackProduct();
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (!entry.isIntersecting) return;
                observer.disconnect();
                this.loadProducts();
            },
            { rootMargin: '0px 0px 200px 0px' }
        );
        observer.observe(this.parentElement || this);
    }

    getHandles() {
        try { return JSON.parse(localStorage.getItem(this.storageKey) || '[]'); }
        catch { return []; }
    }

    trackProduct() {
        if (!this.currentHandle) return;
        let handles = this.getHandles().filter(h => h !== this.currentHandle);
        handles.unshift(this.currentHandle);
        handles = handles.slice(0, this.maxStore);
        try { localStorage.setItem(this.storageKey, JSON.stringify(handles)); }
        catch { /* quota exceeded — silent */ }
    }

    async loadProducts() {
        const handles = this.getHandles()
            .filter(h => h !== this.currentHandle)
            .slice(0, this.maxDisplay);
        if (!handles.length) return;

        const grid = this.querySelector('[id^="Slider-"]');
        if (!grid) return;

        const sectionId = grid.id.replace('Slider-', '');
        const base = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');

        const results = await Promise.all(
            handles.map(h =>
                fetch(`${base}/products/${h}?section_id=recently-viewed-card`)
                    .then(r => r.ok ? r.text() : null)
                    .catch(() => null)
            )
        );

        // Batch all DOM inserts into a single fragment (one reflow)
        const fragment = document.createDocumentFragment();
        let count = 0;

        for (const html of results) {
            if (!html) continue;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const card = doc.querySelector('.rv-card-wrapper');
            if (!card) continue;
            count++;
            const li = document.createElement('li');
            li.id = `Slide-${sectionId}-${count}`;
            li.className = 'grid__item slider__slide';
            li.appendChild(card);
            fragment.appendChild(li);
        }

        if (!count) return;

        grid.appendChild(fragment);
        this.removeAttribute('hidden');

        requestAnimationFrame(() => {
            const slider = this.querySelector('slider-component');
            if (slider?.resetPages) slider.resetPages();
        });
    }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
